exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#login-form{\n  max-width: 30em;\n  margin: auto;\n}\n\n#submit, #already{\n  text-align: center;\n}\n\n.field label{\n  color: #FFFFFF;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/_components/transport-details/transport-details.component.css
// module id = ../../../../../src/app/_components/transport-details/transport-details.component.css
// module chunks = main